import yourcoachsectionimage from "assets/images/your_coach_section_image.png";
import { YOUR_COACH_PARAM } from "constants/general";
import { routes } from "./routes";
/**
 * @description Used for article card
 */
export const READ_MORE = "Read more";
export const READ_LESS = "Read less";

/**
 * @description Used for Profile details
 */

export const FIRSTNAME_ERROR_TEXT =
  "First Name is required and must be at least 3 characters and it should not include numbers or special characters";
export const LASTNAME_ERROR_TEXT =
  "Last Name is required and must be at least 3 characters and it should not include numbers or special characters";
export const SEX_ASSIGNED_AT_BIRTH_ERROR_TEXT =
  "Please select an option for sex assigned at birth";
export const ETHNICITY_ERROR_TEXT = "Please select an option for ethnicity";
export const DATEOFBIRTH_ERROR_TEXT = "Please pick a date";

export const ABOUT_YOU_TEXT =
  "This is the information you provided us with in the Canesmeno guide. You can edit it, but keep in mind it may update your topic of interest and content shown to you.";

// The static card content under Your Coach section in explore all page.
export const ARTICLE_YOUR_COACH_CARD = {
  article_id: YOUR_COACH_PARAM,
  title:
    "Coming Soon: Empowering Your Menopause Journey with Our Holistic and Emotional Support Coaching Program",
  image_path: yourcoachsectionimage,
  field_teaser_title: "your-coach",
  field_article_content: {
    processed: `<p>We've partnered with Karen Heras-Kelly CPCC, a renowned feminine empowerment expert and Certified Professional Coach, to guide and support you through the changes of menopause.</p>
<p>Karen’s influence helps women to deal with the immediate signs and their impact in a way that brings relief and creates new pathways. She opens up new perspectives and builds self-awareness, and compassion.</p>
<p>A key part of her work is to support you to connect to your feminine power as a woman in midlife and help you speak up for your immediate needs. She takes you on the ultimate empowerment journey, one that will leave you feeling grounded, inspired and able to manage, and thrive.</p>
<p>From using EFT based tapping techniques to manage anxiety to powerful visualisations to positively open up your body and mind, Karen uses her extensive knowledge and toolkit to lift you up.</p>
<p>She shows you the real meaning of the menopause as a key and crucial life-stage. And connects you to feminine architypes to ensure that you feel resourced and in awe of who you are as a woman today.</p>
<h4>What is the Holistic Emotional Support Coaching Program?</h4>
<p>Our Holistic Emotional Support Coaching Program is designed to harmonise your mind and body, fostering self-compassion and helping you rediscover your inner strength. Through a curated collection of 30 proven tools and techniques, as well as 60 videos and audios, the program offers a reflective journey, addresses taboos, and provides a holistic check-in with your mind and body. Karen will equip you with the right tools to feel empowered to manage your menopause journey.</p>
<p>Through this programme you will feel be able to create new goals and find success, no matter your challenges.</p>
<p>Stay tuned for the launch of the program!</p>`,
  },
  tags: [{ category_name: "Journey" }, { category_name: "Intro" }],
  field_metatags: {
    title: "Menopause Emotional Support Coaching Program | CanesMeno",
    description:
      "We've partnered with Karen Heras-Kelly, a renowned feminine empowerment expert, to guide and support you through the changes of menopause.",
  },
};

export const TRACKER = {
  HEADING: "Track your menopause",
  DESCRIPTION:
    "To support the discussion with your doctor, track your daily menopausal signs and gain a deeper understanding over time.",
  INFO_DESCRIPTION:
    "You can use the tracker daily, several times a week or just once a week. You can choose to track whichever signs are relevant to you. Please note that incomplete tracking may impact the accuracy of the data. ",
  PERIOD_LOG_SUCCESS: "You've logged your period today",
  PERIOD_LOG_TITLE: "Have you had your period today?",
  PERIOD_LOG_DESCRIPTION:
    "You may no longer have your period, but if you do, tracking it can help facilitate conversations with your doctor",
  PERIOD_LOG_BUTTON: {
    LOGGED: "Period Logged",
    REMOVE: "Remove period log",
    DEFAULT: "Log Period",
  },
};

export const OFFLINE_TEXT = {
  HEADING: "Oops, this content can’t be loaded",
  SUB_HEADING: "because you’re having <strong>connectivity problems</strong>",
};

export const ERROR_TEXT = "Oops, an unexpected error occured";

export const COUNTRY_GETSELECTED_ERROR =
  "Oops, unable to get country preference";
export const COUNTRY_SAVESELECTED_ERROR =
  "Oops, unable to save country preference";
export const MQ6 =
  "Please answer all questions to continue the survey. Your input is essential for us to provide accurate results.";

export const CONSENT_DATA = `We will only use your data with your consent, which you can revoke at any time. For more details, please see our <a href=${routes.privacyStatement.path}>Privacy Statement.</a>`;
export const RESULTS_PDF_TEXT = {
  HEADER: "CanesMeno",
  TRADEMARK: "®",
  SUBHEADER: "Guide",
  RESULTS_TEXT: "YOUR RESULTS",
  GRAPH_HEADER: "The different stages of menopause",
  FOOTER_TEXT:
    "*The Menopause Quick 6 (MQ6) questionnaire has been adapted and reproduced with permission from the College of Family Physicians of Canada from: Goldstein S. An efficient tool for the primary care management of menopause. Can Fam Physician. 2017 Apr;63(4):295-298.",
  FOOTER_LABEL: "Explore the CanesMeno® Hub",
};

export const NOTIFICATION_TEXT = {
  SUCCESS: "success" as "success",
  ERROR: "error" as "error",
  INFO: "info" as "info",
  ALERT: "Browser Alert",
  GRANTED_TITLE: "Notifications Enabled",
  DENIED_TITLE: "Notifications Blocked",
  AWAITING_TITLE: "Notifications Awaiting",
  BROWSER_NOT_SUPPORTED_TITLE: "Browser Issue",
  APPLE_NOT_SUPPORTED_TITLE: "Quick Setup for Apple",
  GRANTED:
    "Great! You’ve successfully enabled push notifications for your browser.",
  DENIED:
    "Oops! It looks like you’ve denied push notifications in your browser. Please enable them to fully enjoy the CanesMeno® Hub.",
  AWAITING:
    "To receive app notifications, please enable them in your browser for the best experience with the CanesMeno® Hub.",
  BROWSER_NOT_SUPPORTED:
    "Unfortunately, your browser does not support notifications. We recommend using a different browser to access the CanesMeno® Hub.",
  APPLE_NOT_SUPPORTED:
    "To receive push notifications, please add the CanesMeno® Hub as a shortcut to your Apple device’s home screen.",
};

export const ESP_CONTENTS: any = {
  INTRO: {
    HEADING: `Support Your Menopause Journey with Karen Heras-Kelly’s Holistic
            “M-Powerment” Coaching Programmes`,
    CONTENT_LESS: `<p>
        We've partnered with Karen Heras-Kelly CPCC, a renowned feminine
        empowerment expert and Certified Professional Coach, to guide and
        support you through the changes of menopause...
      </p>`,
    CONTENT_FULL: `<p>
        We've partnered with Karen Heras-Kelly CPCC, a renowned feminine
        empowerment expert and Certified Professional Coach, to guide and
        support you through the changes of menopause.
      </p>
          <p>
              Karen‘s “M-Powerment” Programme is designed to harmonise your mind and
              body, fostering self-compassion and helping you rediscover your inner
              strength. Through a curated collection of 30 tools and
              techniques, as well as 60 videos and audios, the program offers a
              reflective journey, addresses taboos, and provides a holistic check-in
              with your mind and body. Karen will equip you with the right tools to
              feel empowered to manage your menopause journey.
          </p>`,
  },
  MPOWERMENT: {
    HEADING: `The “M-Powerment” Programme`,
    CONTENT_LESS: `<p>
        Throughout our journey together in the “M-Powerment” Programme, we will explore four key modules, each aimed at equipping you with the tools and insights necessary to help navigate this season with confidence and grace.
      </p>
      <p>
        In <b>‘Menopause Journey’</b> we will explore the menopause experience
        as a natural and transformative phase of life. You’ll learn to embrace
        the change...</p>
        `,
    CONTENT_FULL: `<p >
        Throughout our journey together in the “M-Powerment” Programme, we will explore four key modules, each aimed at equipping you with the tools and insights necessary to help navigate this season with confidence and grace.
      </p>
      <p>
        In <b>‘Menopause Journey’</b> we will explore the menopause experience as a natural and transformative phase of life. You’ll learn to embrace the changes, recognise the wisdom that comes with this journey, and understand how to help navigate the emotional and physical shifts with resilience and empowerment. 
      </p>
      <p>
        In <b>‘Taboos’</b> we will be breaking free from the outdated taboos and
        societal beliefs surrounding menopause. You will uncover hidden stresses
        and limiting beliefs that may have previously held you back.
      </p>
      <p>
        The <b>‘Mind’</b> module will focus on rewiring your mind for clarity
        and strength. You’ll gain insights into managing mental fog, self-doubt,
        and overwhelm.
      </p>
      <p>
        In the <b>‘Body’</b> module, we will reconnect with the incredible
        wisdom of your body. You’ll learn to listen to its signals and
        understand its needs, enhancing your energy and vitality.
      </p>`,
  },
};
export const APP_CONSENT = {
  HEADING: "Your Data & Privacy",
};
export const FAQ_PAGE = {
  HEADING: "Frequently Asked Questions",
};
export const COUNTRY_PAGE = {
  HEADING: "Country / Region",
};
export const HOME_PAGE = {
  MOOD_TRACKER: "Log how you are feeling today",
};

export const YOUR_COACH_DESCRIPTION =
  "We've partnered with Karen Heras-Kelly CPCC, a renowned feminine empowerment expert and Certified Professional Coach, to guide and support you through the changes of menopause. Karen‘s “M-Powerment” Programme is designed to harmonise your mind and body, fostering self-compassion and helping you rediscover your inner strength.";
export const TRACKER_COMPLETE_MODAL = {
  HEADING: "You've completed tracking signs of hot flushes and night sweats.",
  CONTENT: `Tracking the full range of menopause signs will provide a more complete
        picture of your menopause journey. This holistic tracking can help
        improve the accuracy of insights and gain a deeper understanding of your
        signs.`,
};

export const INSIGHTS = {
  TITLE: "Your Insights",
  TITLE_INFO:
    "Please note that the insights and trends displayed are derived from your input in the tracker. Please note that incomplete tracking may impact the accuracy of the data.",
  INSIGHTS_CARD_INFO:
    "These are the signs you tracked most frequently, and with a higher impact on your life, for the selected time period. Please note that incomplete tracking may impact the accuracy of the data.",
};
export const WELCOME_PAGE = {
  LOGO_ALT: "Canesmeno logo",
  HEADING: {
    PART_1: "Welcome to",
    PART_2: "CanesMeno® Hub",
  },
  BROUGHT_TO_YOU_ALT: "Brought to you by the makers of Canesten®",
  DESCRIPTION:
    "Menopause can be confusing, but you are not alone in this journey.Your personal menopause app & tracker",
  ACTION_BUTTONS: {
    GET_STARTED: "GET STARTED",
    LOGIN: "already have an account? login",
  },
  FOOTER: {
    DESCRIPTION: `<p>
                  *IRI unit sales data including Thrush, Bacterial Vaginosis, Cystitis and Vaginal Dryness segments. 
                  <br/>
                  To verify contact <a href="mailto:consumerhealthuk@bayer.com">consumerhealthuk@bayer.com</a>
              </p>`,
    PROFILE_BUTTON: "Profile & Settings",
  },
};

export const INTRO_PAGE = {
  ACTION_BUTTONS: {
    NEXT: "Next",
  },
};

export const CONTACT_US_FORM = {
  TOPIC_REQUIRED_ERROR: "Topic is required",
  EMAIL_REQUIRED_ERROR: "Email is required",
  EMAIL_INVALID_ERROR: "Please enter a valid email",
  MESSAGE_REQUIRED_ERROR: "Message is required",
};
